import { FC, useCallback } from 'react'
import * as styles from 'components/features/pfm/NotificationTray/NotificationTray.css'
import { TextIconNotification } from 'interfaces/notifications'
import { dismissNotificationActionCreator } from 'actions/notificationsActions'
import Icon from 'components/atoms/Icon'
import InsightButton, { NoLink } from 'components/features/insights/InsightButton/InsightButton'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'

type TextIconNotificationItemProps = {
  notification: TextIconNotification
}

export const TextIconNotificationItem: FC<TextIconNotificationItemProps> = (props) => {
  const {
    notification,
  } = props

  const { icon, text } = notification
  const dispatch = useStoreDispatch()
  const handleDismiss = useCallback((id: string) => {
    dispatch(dismissNotificationActionCreator(id))
  }, [dispatch])

  return (
    <div className={ styles.itemInner }>
      { icon && (
        <div className={ styles.iconInRow }>
          <Icon kind={ icon } />
        </div>
      )}
      <section className={ styles.itemContent }>
        <section className={ styles.itemText }>
          { text }
        </section>
        <section className={ styles.buttons }>
          <InsightButton
            linkComponent={ NoLink }
            theme='text-only'
            onClick={ () => handleDismiss(notification.id) }
          >
            Dismiss
          </InsightButton>
        </section>
      </section>
    </div>
  )
}
